function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/dom/resizeobserver
 */

/* globals setTimeout, clearTimeout */
import mix from '../mix';
import global from './global';
import Rect from './rect';
import DomEmitterMixin from './emittermixin';
var RESIZE_CHECK_INTERVAL = 100;
/**
 * A helper class which instances allow performing custom actions when native DOM elements are resized.
 *
 *		const editableElement = editor.editing.view.getDomRoot();
 *
 *		const observer = new ResizeObserver( editableElement, entry => {
 *			console.log( 'The editable element has been resized in DOM.' );
 *			console.log( entry.target ); // -> editableElement
 *			console.log( entry.contentRect.width ); // -> e.g. '423px'
 *		} );
 *
 * By default, it uses the [native DOM resize observer](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver)
 * under the hood and in browsers that do not support the native API yet, a polyfilled observer is
 * used instead.
 */

var ResizeObserver = /*#__PURE__*/function () {
  /**
   * Creates an instance of the `ResizeObserver` class.
   *
   * @param {HTMLElement} element A DOM element that is to be observed for resizing. Note that
   * the element must be visible (i.e. not detached from DOM) for the observer to work.
   * @param {Function} callback A function called when the observed element was resized. It passes
   * the [`ResizeObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry)
   * object with information about the resize event.
   */
  function ResizeObserver(element, callback) {
    _classCallCheck(this, ResizeObserver);

    // **Note**: For the maximum performance, this class ensures only a single instance of the native
    // (or polyfilled) observer is used no matter how many instances of this class were created.
    if (!ResizeObserver._observerInstance) {
      ResizeObserver._createObserver();
    }
    /**
     * The element observer by this observer.
     *
     * @readonly
     * @private
     * @member {HTMLElement}
     */


    this._element = element;
    /**
     * The callback executed each time {@link #_element} is resized.
     *
     * @readonly
     * @private
     * @member {Function}
     */

    this._callback = callback;

    ResizeObserver._addElementCallback(element, callback);

    ResizeObserver._observerInstance.observe(element);
  }
  /**
   * Destroys the observer which disables the `callback` passed to the {@link #constructor}.
   */


  _createClass(ResizeObserver, [{
    key: "destroy",
    value: function destroy() {
      ResizeObserver._deleteElementCallback(this._element, this._callback);
    }
    /**
     * Registers a new resize callback for the DOM element.
     *
     * @private
     * @static
     * @param {HTMLElement} element
     * @param {Function} callback
     */

  }], [{
    key: "_addElementCallback",
    value: function _addElementCallback(element, callback) {
      if (!ResizeObserver._elementCallbacks) {
        ResizeObserver._elementCallbacks = new Map();
      }

      var callbacks = ResizeObserver._elementCallbacks.get(element);

      if (!callbacks) {
        callbacks = new Set();

        ResizeObserver._elementCallbacks.set(element, callbacks);
      }

      callbacks.add(callback);
    }
    /**
     * Removes a resize callback from the DOM element. If no callbacks are left
     * for the element, it removes the element from the native observer.
     *
     * @private
     * @static
     * @param {HTMLElement} element
     * @param {Function} callback
     */

  }, {
    key: "_deleteElementCallback",
    value: function _deleteElementCallback(element, callback) {
      var callbacks = ResizeObserver._getElementCallbacks(element); // Remove the element callback. Check if exist first in case someone
      // called destroy() twice.


      if (callbacks) {
        callbacks.delete(callback); // If no callbacks left for the element, also remove the element.

        if (!callbacks.size) {
          ResizeObserver._elementCallbacks.delete(element);

          ResizeObserver._observerInstance.unobserve(element);
        }
      }

      if (ResizeObserver._elementCallbacks && !ResizeObserver._elementCallbacks.size) {
        ResizeObserver._observerInstance = null;
        ResizeObserver._elementCallbacks = null;
      }
    }
    /**
     * Returns are registered resize callbacks for the DOM element.
     *
     * @private
     * @static
     * @param {HTMLElement} element
     * @returns {Set.<HTMLElement>|null}
     */

  }, {
    key: "_getElementCallbacks",
    value: function _getElementCallbacks(element) {
      if (!ResizeObserver._elementCallbacks) {
        return null;
      }

      return ResizeObserver._elementCallbacks.get(element);
    }
    /**
     * Creates the single native observer shared across all `ResizeObserver` instances.
     * If the browser does not support the native API, it creates a polyfill.
     *
     * @private
     * @static
     */

  }, {
    key: "_createObserver",
    value: function _createObserver() {
      var ObserverConstructor; // TODO: One day, the `ResizeObserver` API will be supported in all modern web browsers.
      // When it happens, this module will no longer make sense and should be removed and
      // the native implementation should be used across the project to save bytes.
      // Check out https://caniuse.com/#feat=resizeobserver.

      if (typeof global.window.ResizeObserver === 'function') {
        ObserverConstructor = global.window.ResizeObserver;
      } else {
        ObserverConstructor = ResizeObserverPolyfill;
      }

      ResizeObserver._observerInstance = new ObserverConstructor(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;

            var callbacks = ResizeObserver._getElementCallbacks(entry.target);

            if (callbacks) {
              var _iterator2 = _createForOfIteratorHelper(callbacks),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var callback = _step2.value;
                  callback(entry);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);

  return ResizeObserver;
}();
/**
 * The single native observer instance (or polyfill in browsers that do not support the API)
 * shared across all {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
 *
 * @static
 * @protected
 * @readonly
 * @property {Object|null} module:utils/dom/resizeobserver~ResizeObserver#_observerInstance
 */


export { ResizeObserver as default };
ResizeObserver._observerInstance = null;
/**
 * A mapping of native DOM elements and their callbacks shared across all
 * {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
 *
 * @static
 * @private
 * @readonly
 * @property {Map.<HTMLElement,Set>|null} module:utils/dom/resizeobserver~ResizeObserver#_elementCallbacks
 */

ResizeObserver._elementCallbacks = null;
/**
 * A polyfill class for the native [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver).
 *
 * @private
 * @mixes module:utils/domemittermixin~DomEmitterMixin
 */

var ResizeObserverPolyfill = /*#__PURE__*/function () {
  /**
   * Creates an instance of the {@link module:utils/dom/resizeobserver~ResizeObserverPolyfill} class.
   *
   * It synchronously reacts to resize of the window to check if observed elements' geometry changed.
   *
   * Additionally, the polyfilled observer uses a timeout to check if observed elements' geometry has changed
   * in some other way (dynamic layouts, scrollbars showing up, etc.), so its response can also be asynchronous.
   *
   * @param {Function} callback A function called when any observed element was resized. Refer to the
   * native [`ResizeObserver`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) API to
   * learn more.
   */
  function ResizeObserverPolyfill(callback) {
    _classCallCheck(this, ResizeObserverPolyfill);

    /**
     * A function called when any observed {@link #_elements element} was resized.
     *
     * @readonly
     * @protected
     * @member {Function}
     */
    this._callback = callback;
    /**
     * DOM elements currently observed by the observer instance.
     *
     * @readonly
     * @protected
     * @member {Set}
     */

    this._elements = new Set();
    /**
     * Cached DOM {@link #_elements elements} bounding rects to compare to upon the next check.
     *
     * @readonly
     * @protected
     * @member {Map.<HTMLElement,module:utils/dom/rect~Rect>}
     */

    this._previousRects = new Map();
    /**
     * An UID of the current timeout upon which the observed elements rects
     * will be compared to the {@link #_previousRects previous rects} from the past.
     *
     * @readonly
     * @protected
     * @member {Map.<HTMLElement,module:utils/dom/rect~Rect>}
     */

    this._periodicCheckTimeout = null;
  }
  /**
   * Starts observing a DOM element.
   *
   * Learn more in the
   * [native method documentation](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/observe).
   *
   * @param {HTMLElement} element
   */


  _createClass(ResizeObserverPolyfill, [{
    key: "observe",
    value: function observe(element) {
      this._elements.add(element);

      this._checkElementRectsAndExecuteCallback();

      if (this._elements.size === 1) {
        this._startPeriodicCheck();
      }
    }
    /**
     * Stops observing a DOM element.
     *
     * Learn more in the
     * [native method documentation](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/unobserve).
     *
     * @param {HTMLElement} element
     */

  }, {
    key: "unobserve",
    value: function unobserve(element) {
      this._elements.delete(element);

      this._previousRects.delete(element);

      if (!this._elements.size) {
        this._stopPeriodicCheck();
      }
    }
    /**
     * When called, the observer calls the {@link #_callback resize callback} for all observed
     * {@link #_elements elements} but also starts checking periodically for changes in the elements' geometry.
     * If some are detected, {@link #_callback resize callback} is called for relevant elements that were resized.
     *
     * @protected
     */

  }, {
    key: "_startPeriodicCheck",
    value: function _startPeriodicCheck() {
      var _this = this;

      var periodicCheck = function periodicCheck() {
        _this._checkElementRectsAndExecuteCallback();

        _this._periodicCheckTimeout = setTimeout(periodicCheck, RESIZE_CHECK_INTERVAL);
      };

      this.listenTo(global.window, 'resize', function () {
        _this._checkElementRectsAndExecuteCallback();
      });
      this._periodicCheckTimeout = setTimeout(periodicCheck, RESIZE_CHECK_INTERVAL);
    }
    /**
     * Stops checking for changes in all observed {@link #_elements elements} geometry.
     *
     * @protected
     */

  }, {
    key: "_stopPeriodicCheck",
    value: function _stopPeriodicCheck() {
      clearTimeout(this._periodicCheckTimeout);
      this.stopListening();

      this._previousRects.clear();
    }
    /**
     * Checks if the geometry of any of the {@link #_elements element} has changed. If so, executes
     * the {@link #_callback resize callback} with element geometry data.
     *
     * @protected
     */

  }, {
    key: "_checkElementRectsAndExecuteCallback",
    value: function _checkElementRectsAndExecuteCallback() {
      var entries = [];

      var _iterator3 = _createForOfIteratorHelper(this._elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var element = _step3.value;

          if (this._hasRectChanged(element)) {
            entries.push({
              target: element,
              contentRect: this._previousRects.get(element)
            });
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (entries.length) {
        this._callback(entries);
      }
    }
    /**
     * Compares the DOM element geometry to the {@link #_previousRects cached geometry} from the past.
     * Returns `true` if geometry has changed or the element is checked for the first time.
     *
     * @protected
     * @param {HTMLElement} element
     * @returns {Boolean}
     */

  }, {
    key: "_hasRectChanged",
    value: function _hasRectChanged(element) {
      if (!element.ownerDocument.body.contains(element)) {
        return false;
      }

      var currentRect = new Rect(element);

      var previousRect = this._previousRects.get(element); // The first check should always yield true despite no Previous rect to compare to.
      // The native ResizeObserver does that and... that makes sense. Sort of.


      var hasChanged = !previousRect || !previousRect.isEqual(currentRect);

      this._previousRects.set(element, currentRect);

      return hasChanged;
    }
  }]);

  return ResizeObserverPolyfill;
}();

mix(ResizeObserverPolyfill, DomEmitterMixin);